// extracted by mini-css-extract-plugin
module.exports = {"header":"ErrorPage_header__8o0cV","aside":"ErrorPage_aside__mUCHv","title":"ErrorPage_title__23sMK","text":"ErrorPage_text__nIVvC"};